export default Object.freeze({
    MaximumParcelWeightInGrams: 30000,
    SenderIslands: {
        Malta: 'Malta',
        Gozo: 'Għawdex'
    }
});